"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useElementOnScreen;
var _react = require("react");
/**
 * Hook to observe if an element is visible within the viewport or a parent element.
 *
 * @param {Options} options - Configuration options for the IntersectionObserver.
 * @param {null | Element} options.root - The root element to use for intersection.
 * @param {string} options.rootMargin - Margin around the root for the intersection area.
 * @param {number} options.threshold - Visibility threshold (0 to 1).
 *
 * @returns {Response} - A tuple containing the ref to attach and a visibility state.
 */
function useElementOnScreen(options) {
  var _options$defaultValue;
  const [isVisible, setIsVisible] = (0, _react.useState)((_options$defaultValue = options === null || options === void 0 ? void 0 : options.defaultValue) !== null && _options$defaultValue !== void 0 ? _options$defaultValue : true);
  const ref = (0, _react.useRef)(null);
  const handleObserver = (0, _react.useCallback)(entries => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  }, [setIsVisible]);
  (0, _react.useEffect)(() => {
    const observer = new IntersectionObserver(handleObserver, options);
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [ref, options]);
  return [ref, isVisible];
}